import type { MoneyFormatter } from "../../money/MoneyFormatter";
import type { CurrentWinStore } from "./CurrentWinStore";
import type { CurrentWinPort } from "./CurrentWinPort";

export class CurrentWinPresenter {
  private readonly formatter: MoneyFormatter;
  private readonly store: CurrentWinStore;
  private readonly panel: CurrentWinPort;

  private unsubscribe?: () => void;

  public constructor(input: { formatter: MoneyFormatter; store: CurrentWinStore; panel: CurrentWinPort }) {
    this.formatter = input.formatter;
    this.store = input.store;
    this.panel = input.panel;
  }

  public start(): void {
    this.render();
    this.unsubscribe = this.store.subscribe(() => this.render());
  }

  public stop(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
  }

  public render(): void {
    const snap = this.store.getSnapshot();
    this.panel.setVisible(snap.visible);

    if (!snap.visible) return;

    const text = this.formatter.formatMinor(snap.currentWinMinor);
    this.panel.setText(text);
  }
}